import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-payment-completed',
  templateUrl: './payment-completed.component.html',
  styleUrls: ['./payment-completed.component.css']
})
export class PaymentCompletedComponent implements OnInit {

  constructor(private route: ActivatedRoute, private afs: AngularFirestore) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const idUser = params['idUser'];
      const urlData = `payments/${idUser}`;
      this.afs.doc(urlData).get().subscribe(user =>
        {
           const userData = user.data();
           userData['paidCompleted'] = true;
           this.afs.doc(urlData).set(userData);
        })
    });
  }

}
